module.exports = __webpack_public_path__ + "img/cademi.0b6adf6e.svg";